import React from "react";
import classes from './PrivateQuestionList.module.scss'

const data = [
    { label: 'In what city were you born', value: '1' },
    { label: 'What is the name of your favorite pet', value: '2' },
    { label: "What is your mother's maiden name", value: '3' },
    { label: 'What high school did you attend', value: '4' },
    { label: 'What is the name of your first school', value: '5' },
    { label: 'What was the make of your first car', value: '6' },
    { label: 'What was your favorite food as a child', value: '7' },
    { label: 'Where did you meet your spouse', value: '8' },
];

export const PrivateQuestionList = (props:any) => {
    return(
        <div className={props.isVisible ? `${classes.list} ${classes.list_active}`: classes.list}>
            {data.map((el, key) => {
                return (
                    <div className={classes.list_item} onClick={() => props.onChangeValue(el.label)} key={el.value}>
                        {el.label}
                    </div>
                )
            })}
        </div>
    )
}